import './style.scss';
import { useState, useEffect } from 'react';
import { useHistory } from "react-router-dom";
import {useTranslation} from "react-i18next";
import AuthService from "../../shared/authService";
import Utils from "../../shared/utils";
import ConfigService from '../../shared/configService';
import { Spinner } from 'react-bootstrap';
import Constants from '../../shared/constants';
import { ToastContainer, toast } from 'react-toastify';
import LoadingOverlay from 'react-loading-overlay';


const Login = () => {
    const history = useHistory();
    const {t} = useTranslation('login');

    const [state, setState] = useState({
        keepSignedIn: window.localStorage.getItem(Constants.IUCN_KEEP_SIGNED_IN) === 'on',
        userLoaded: AuthService.checkConnectedUser(),
        login: '',
        pass: '',
        isLoggedIn: false,
        loginError: false,
        isLoading: false
    });

    /**
     * Effect
     */
    useEffect(() => {    
        checkKeepSignedIn();
    }, []);

    useEffect(() => {
        if(state.userLoaded) {
            history.push(ConfigService.getConfig().routes?.submissionTool.reports || '');
        }
    }, [state.userLoaded]);

    /**
     * Sign in to AGOL
     */
    const doSignIn = async(e: React.FormEvent) => {
        try {
            e.preventDefault();

            // 1) SSO login
            if((e.currentTarget as any).id === 'ssoLoginBtn') {
                const loggedIn: boolean = await AuthService.getInstance().authenticateUser();
            }
            // 2) Arcgis Login
            else {
                Utils.setStateValue('isLoading', true, state, setState);
                const loggedIn: boolean = await AuthService.getInstance().authenticateUser(state.login, state.pass);
                if(loggedIn) {
                    Utils.setStateValue('isLoggedIn', loggedIn, state, setState);
                    Utils.setStateValue('isLoading', false, state, setState);
                    history.push(ConfigService.getConfig().routes?.submissionTool.reports || '');
                } else {
                    showError();
                }
            }
        } catch(err: any) {
            showError();
        }
    };

    /**
     * Show login error
     */
    const showError = () => {        
        Utils.setStateValue('isLoading', false, state, setState);
        toast.error(t('loginFailed'));
    }

    /**
     * Check keep signed in
     * @returns 
     */
    const checkKeepSignedIn = (): boolean => {        
        const keepSignedIn = state.isLoggedIn || window.localStorage.getItem(Constants.IUCN_KEEP_SIGNED_IN) === 'on';
        setKeepSignedIn(keepSignedIn);
        return keepSignedIn;
    }
    
    /**
     * Set signed in
     * @param checked 
     */
    const setKeepSignedIn = (checked: boolean) => {
        window.localStorage.setItem(Constants.IUCN_KEEP_SIGNED_IN, checked ? 'on' : 'off');
        Utils.setStateValue('keepSignedIn', checked, state, setState);
    }

    return (
        <div className="loginDiv" style={{backgroundImage: `url("${process.env.PUBLIC_URL}/assets/background/login-bg.svg")`}}>
            
            <div className="row veryBigText pageTitle">
                <span>{t('title')}</span> 
            </div>
    
            <form className="row loginForm shadow-lg p-3 mb-5 bg-white big-border-radius" onSubmit={(e) => doSignIn(e)}>
                <div className="ssoLoginDiv">
                    <button id="ssoLoginBtn" className="signInBtn primary" type="button" onClick={doSignIn}>                        
                        <span>{t('signinIUCN')}</span>
                    </button>
                </div>

                <div className="row">            
                    <span className="titleSpan mediumText">{t('arcgisLogin')}</span>   
                </div>

                <div className="row">            
                    <input className="mediumText" type="text" placeholder={t('usernamePlaceholder')} required value={state.login} onChange={(e) => {Utils.setStateValue('login', e.target.value, state, setState)}}/>  
                </div>
                
                <div className="row inputMargin">            
                    <input className="mediumText" type="password" placeholder={t('passwordPlaceholder')} value={state.pass} onChange={(e) => {Utils.setStateValue('pass', e.target.value, state, setState)}} />  
                </div>

                <div className="row keepSigned">
                    <div className="form-check form-switch">
                        <input className="form-check-input" type="checkbox" id="keepSignedCbx" checked={state.keepSignedIn} onChange={(e) => {setKeepSignedIn(e.target.checked)}}/>
                        <label className="form-check-label mediumText" htmlFor="keepSignedCbx">{t('keepSignedIn')}</label>
                    </div>
                </div>
                
                {!state.isLoggedIn && 
                <div className="row">            
                    <button className="signInBtn primary" type="submit">                        
                        <span>{t('signin')}</span>
                    </button>
                </div>
                }
            </form>

            <LoadingOverlay
                active={state.isLoading}
                spinner
                text= {state.isLoading ? t('connecting') : ''}>
            </LoadingOverlay>

            <ToastContainer 
                position="bottom-center"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover/>
        </div>
    )
};

export default Login;

